module.exports = __webpack_public_path__ + "static/lightning-table-borderless-fba66f5d5664333b5d6d57aecb7a1322.png";